import React from "react";

export default function PaymentTypeModal({
  isOpen,
  isVideo,
  paymentType,
  expiryDate,
  onPaymentTypeChange,
  onExpiryDateChange,
  onClose,
  onConfirm,
}) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[60]">
      <div className="bg-white p-6 rounded-lg w-1/3">
        <h3 className="text-xl font-semibold mb-4">Select Payment Type</h3>
        <div className="mb-4">
          <label className="flex items-center mb-2">
            <input
              type="radio"
              value="cash"
              checked={paymentType === "cash"}
              onChange={(e) => onPaymentTypeChange(e.target.value)}
              className="mr-2"
            />
            Cash
          </label>
          <label className="flex items-center">
            <input
              type="radio"
              value="bank-in"
              checked={paymentType === "bank-in"}
              onChange={(e) => onPaymentTypeChange(e.target.value)}
              className="mr-2"
            />
            Bank-in
          </label>
        </div>
        {isVideo && (
          <div className="mb-4">
            <label className="block text-gray-700 mb-1">Expiry Date:</label>
            <input
              type="date"
              value={expiryDate}
              onChange={(e) => onExpiryDateChange(e.target.value)}
              className="border rounded w-full py-2 px-3"
              required
            />
          </div>
        )}
        <div className="flex justify-end space-x-2">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
}
